import { withErrorBoundary } from 'ui';
import { ProgramLayout } from '../program-layout';
import { ProgramAboutContent } from './program-about-content';

type P = {
  programId: string;
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramAbout = ({ programId }: P) => (
  <ProgramLayout children={(program) => <ProgramAboutContent program={program} />} programId={programId} />
);

export default withErrorBoundary(ProgramAbout);
